import { useState } from "react";
import { api } from "@/lib/api";
import { FileDown } from "lucide-react";
import { toast } from "sonner";

export const StatutoryExport = ({ formCode, panchayatId, fy }) => {
  const [lang, setLang] = useState("en");
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get(`/statutory-forms/${formCode}/pdf`, {
        params: { lang, panchayat_id: panchayatId || undefined, fy: fy || undefined },
        responseType: "blob",
      });
      const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
      window.open(url, "_blank");
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (e) {
      toast.error("PDF export failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="inline-flex items-center rounded-md border border-slate-300 overflow-hidden bg-white">
      <select value={lang} onChange={(e) => setLang(e.target.value)}
        data-testid={`statutory-lang-${formCode}`}
        className="px-2 py-2 text-xs bg-white outline-none border-r border-slate-200">
        <option value="en">English</option>
        <option value="hi">हिन्दी</option>
        <option value="gu">ગુજરાતી</option>
      </select>
      <button onClick={download} disabled={busy} data-testid={`statutory-pdf-${formCode}`}
        className="inline-flex items-center gap-1.5 px-3 py-2 text-xs font-semibold text-white disabled:opacity-60"
        style={{ background: "#0A3161" }}>
        <FileDown className="w-3.5 h-3.5" /> {busy ? "…" : `Form ${formCode} PDF`}
      </button>
    </div>
  );
};
